import { render, staticRenderFns } from "./global-view.vue?vue&type=template&id=7ceff58c"
import script from "./global-view.vue?vue&type=script&lang=js"
export * from "./global-view.vue?vue&type=script&lang=js"
import style0 from "./global-view.vue?vue&type=style&index=0&id=7ceff58c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports